import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { ProductOfferFragment } from '@/services/graphql/generated'

type Offer = {
  displayItems: ProductOfferFragment['displayItems']
  deductible?: ProductOfferFragment['deductible']
  variant: Pick<ProductOfferFragment['variant'], 'displayNameTier'>
  addons: ProductOfferFragment['addons']
  priceIntentData: ProductOfferFragment['priceIntentData']
}

export const useOfferDetails = (offer: Offer): Array<{ title: string; value: string }> => {
  const { t } = useTranslation('cart')

  return useMemo(() => {
    const items = offer.displayItems.map((item) => ({
      title: item.displayTitle,
      value: item.displayValue,
    }))

    const tierLevelDisplayName = offer.variant.displayNameTier
    if (tierLevelDisplayName) {
      items.push({ title: t('DATA_TABLE_TIER_LABEL'), value: tierLevelDisplayName })
    }

    const deductibleDisplayName = offer.deductible?.displayName
    if (deductibleDisplayName) {
      items.push({ title: t('DATA_TABLE_DEDUCTIBLE_LABEL'), value: deductibleDisplayName })
    }

    const addons = offer.addons
      .filter((addon) => addon.isSelected)
      .map((addon) => ({
        title: addon.variant.displayName,
        value: addon.coverageText,
      }))
    return [...items, ...addons]
  }, [offer, t])
}
